import { createContext, useState, useEffect } from "react";
import jwt_decode from 'jwt-decode';
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import { BACKEND } from "./backend";

const AuthContext = createContext();

export default AuthContext;

export const AuthProvider = ({ children }) => {

    //localStorage.getItem('authTokens');
    let [authTokens, setAuthTokens] = useState(()=> localStorage.getItem('authTokens') ? JSON.parse(localStorage.getItem('authTokens')) : null)
    let [user, setUser] = useState(() => localStorage.getItem('authTokens') ? jwt_decode(localStorage.getItem('authTokens')) : null)
    let [loading, setLoading] = useState(true);

    const navigate = useNavigate();

    const loginUser = async (e) => {
        e.preventDefault()
        let response = await fetch(BACKEND+'/api/token/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                'username': e.target.username.value,
                'password': e.target.password.value
            })
        })    
        let data = await response.json()

        if (response.status === 200) {
            setAuthTokens(data);
            setUser(jwt_decode(data.access));
            localStorage.setItem('authTokens', JSON.stringify(data));
                
            swal("Bienvenido/a!", {
                button: false,
                icon: "success",
                timer: "1500"
              });
            
            
            navigate('/');
        } else {
            swal({
                title: "Usuario y/o contraseña incorrectos",
                text: "Vuelve a intentarlo.",
                icon: "error",
                button: false,
                timer: "2000"
              });
        }
        
    };

    let endSession = () => {
        swal({
            title: "Finalizar sesion?",
            icon: "warning",
            buttons: {
                cancel: "Cancelar",
                catch: "Salir"
            },
            dangerMode: true,
          })
          .then((willDelete) => {
            if (willDelete) {
                swal("Sesión finalizada", {
                    button: false,
                    icon: "success",
                    timer: "1500"
                });
                logoutUser();
              };
          });
    }


    let logoutUser = () => {
        setAuthTokens(null)
        setUser(null)
        localStorage.removeItem('authTokens')
        navigate('/login')
    }


    let updateToken = async ()=> {

        let response = await fetch(BACKEND+'/api/token/refresh/', {

            method:'POST',
            headers:{
                'Content-Type':'application/json'
            },
            body:JSON.stringify({'refresh':authTokens?.refresh})
        })

        let data = await response.json()
        
        if (response.status === 200){
            setAuthTokens(data)
            setUser(jwt_decode(data.access))
            localStorage.setItem('authTokens', JSON.stringify(data))
        }else{
            logoutUser()
        }

        if(loading){
            setLoading(false)
        }
    }

    // Aca creamos el contexto para pasar a los demas componentes via 'AuthContext'
    let contextData = {
        user: user,
        authTokens:authTokens,
        loginUser: loginUser,
        logoutUser: endSession,
    }


    useEffect(()=> {

        if(loading){
            updateToken();
        }

        let fourMinutes = 1000 * 60 * 4

        let interval =  setInterval(()=> {
            if(authTokens){
                updateToken()
            }
        }, fourMinutes)
        return ()=> clearInterval(interval)

    }, [authTokens, loading])

    return (
        <AuthContext.Provider value={contextData} >
            {loading ? null : children}
        </AuthContext.Provider>
    );
};